import { styled } from '@abyss/web/tools/styled';
import { Button } from '@abyss/web/ui/Button';
import { IconMaterial } from '@abyss/web/ui/IconMaterial';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import { useTranslation } from 'react-i18next';

import { adobeLinkTrackEvent } from '../../../../../common/AdobeTagging/adobeLinkTrackEvent';
import { usePrintPSX } from '../../../../../hooks/usePSXPrint/usePrintPSX';
import { hideChat, hideFeedbackContainer } from '../ShareDrawer/utils';

const PrintButtonStyled = styled(Button, {
  variants: {
    view: {
      mobile: {
        '&.abyss-button-root': {
          width: '100px',
          color: '$gray7',
          fontWeight: '$medium',
        },
      },
      desktop: {
        '&.abyss-button-root': {
          paddingRight: 0,
        },
      },
    },
  },
});

type Props = {
  locationForAnalytics: string;
  view: string;
  showMergedCompareAndShare?: boolean;
  selectedCount?: number;
};

export const PrintButton = ({
  locationForAnalytics,
  view,
  showMergedCompareAndShare,
  selectedCount = 0,
}: Props) => {
  const { printPSXPage } = usePrintPSX();
  const { t } = useTranslation();

  return (
    <PrintButtonStyled
      css={{
        ...(view === 'desktop' &&
          showMergedCompareAndShare && { paddingRight: '20px' }), // Added for desktop view
        '.abyss-icon-symbol': {
          color: selectedCount < 2 ? '$gray5 !important' : '$primary',
        },
      }}
      data-auto-testid="mapview-print-button"
      data-testid="mapview-print-button"
      disabled={selectedCount < 2}
      onClick={() => {
        if (showMergedCompareAndShare) {
          adobeLinkTrackEvent({
            name: 'share a pdf',
            location: 'Compare providers overlay',
            type: 'download',
          });
        } else {
          adobeLinkTrackEvent({
            name: 'print',
            location: locationForAnalytics,
            type: 'internal',
          });
        }
        hideFeedbackContainer(true);
        hideChat(true);
        printPSXPage();
        hideFeedbackContainer(false);
        hideChat(false);
      }}
      variant={showMergedCompareAndShare ? 'outline' : 'tertiary'}
      view={view}
    >
      {showMergedCompareAndShare ? (
        <IconSymbol data-testid="icon-material-download-icon" icon="download" />
      ) : (
        <IconMaterial
          css={{
            'abyss-icon': {
              marginRight: '$xs',
            },
          }}
          data-testid="icon-material-print-icon"
          icon="print"
        />
      )}

      {showMergedCompareAndShare
        ? t('SHARE_DRAWER_TEXT.SHARE_A_PDF')
        : t('SHARE_DRAWER_TEXT.PRINT')}
    </PrintButtonStyled>
  );
};
